import { SELECIONAR_CONEXAO } from '../../actions/types'

const initialState = undefined;

export default function reducerConexaoSelecionada (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_CONEXAO: {
      return action.payload;
    }
    default: {
      return state
    }
  }
}
